import { DetailsTable } from './DetailsTable';

export default DetailsTable;
